import Breadcrumb from "app/components/Breadcrumb";
import { Tabs, Tab, Row, Col, Card} from "react-bootstrap";
import PlatformUsers from "./platFormUser";
import AccessUsers from "../dashboard/userDashboard/AccessUsers";

export default function UserTabDetails() {
    return (
        <div>
          <Tabs defaultActiveKey="KeyfreeUsers" >
                    <Tab eventKey="KeyfreeUsers" title="Brukere">
                        <AccessUsers/>
                    </Tab>
    
                    <Tab eventKey="AdminUsers" title="Administratorer">
                        <PlatformUsers/>
                    </Tab>
                  </Tabs>
        </div>
      );
}